(function ($, _, engines, dataSets) {
    var checkboxModal = (function () {
        var dataName = 'chCheckboxModal';

        function init(type, values) {
            if (this.data(dataName)) {
                destroy.call(this);
            }

            this.data(dataName, {
                type: type,
                showAll: false
            }).on('click', open);

            vals.call(this, values);
        }

        function open() {
            var elm = $(this);

            var config = elm.data(dataName);

            if (config.modal) {
                config.modal.remove();
            }

            var size = 'modal-lg';
            var header = dataSets.get(config.type).templates.header;
            if (!header) {
                header = '';
            } else if ($('.row > div', header).length >= 3) {
                // use large modal for 3 or more columns
                size = 'modal-xl';
            }

            config.modal = $(
                '<div tabindex="-1" role="dialog" class="modal hide ch-checkboxModal">' +
                '<div class="modal-dialog ' + size + '" role="document">' +
                '<div class="modal-content">' +
                '<div class="modal-header">' +
                '<h5 class="modal-title">' + elm.attr('title') + '</h5>' +
                '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' +
                '</div>' +
                '<div class="ml-4">' + header + '</div>' +
                '<div class="modal-body">' +
                '<span class="text-muted">loading...</span>' +
                '</div>' +
                '<div class="modal-footer">' +
                '<a href="javascript:;" class="btn btn-default ch-checkboxModal-all"></a>' +
                '<a href="javascript:;" data-dismiss="modal" class="btn btn-primary">Close</a>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>')
                .appendTo(document.body)
                .modal({})
                .on('hidden', function () {
                    config.modal.remove();
                    config.modal = null;
                    config.showArchive = false;
                });

            $('.modal-footer .ch-checkboxModal-all', config.modal).on('click', function () {
                config.showAll = !config.showAll;
                renderBody.call(elm);
            });

            renderBody.call(elm);
        }

        function renderBody() {
            var elm = this;
            var config = elm.data(dataName);

            engines.getIndex(config.type).then(
                function (data, engine) {
                    if (config.type.toLowerCase() === 'country' || config.type.toLowerCase() === 'workgroup') {
                        data.sort(function (a, b) {
                            // countries are sorted by relevance for typeahead
                            // labels make more sense when listing
                            return a.label < b.label ? -1 : (a.label > b.label ? 1 : 0);
                        });
                    }

                    var dataset = dataSets.get(config.type),
                        suggestion = dataset.templates.suggestion,
                        body = $('.modal-body', config.modal).empty(),
                        showAllLink = $('.ch-checkboxModal-all', config.modal),
                        hasHidden = false;
                    showAllLink.hide();

                    var values = _.clone(config.values);

                    _.each(data, function (datum) {
                        var checked = $.inArray('' + datum.value, values) >= 0;

                        if (engine.index.datumTokenizer(datum).length === 0) {
                            if (!hasHidden) {
                                showAllLink.show();
                                hasHidden = true;
                                showAllLink.html('<i class="fas ' + (config.showAll ? 'fa-check-square' : 'fa-square') + '"></i> Show all');
                            }
                            if (!checked && !config.showAll) {
                                return;
                            }
                        }

                        body.append(getRow(suggestion(datum), datum, checked, elm));

                        if (checked) {
                            _.pull(values, '' + datum.value);
                        }
                    });

                    // unknown values (deleted, no access...)
                    _.each(values, function (value) {
                        body.prepend(getRow(
                            $('<div></div>').text('id:' + value).append(' <i title="no data" class="text-danger far fa-exclamation-triangle"></i>'),
                            { label: value, value: value }, true, elm));
                    });
                },
                function () {
                    $('.modal-body', modal).html('<span class="text-danger">service error</span>');
                });
        }

        function getRow(html, datum, checked, elm) {

            var row = $('<div class="ch-checkboxModal-row form-check mb-3 mb-sm-2">' +
                '<input type="checkbox" class="form-check-input" />' +
                '<label class="form-check-label w-100"></label>' +
                '</div>');
            row.find('.form-check-label').append(html);
            row.on('click', function (e) {
                var cb = $(this).find('input')[0];
                cb.checked = !cb.checked;
                change.call(elm);
            });

            var input = row.find('input')
                .data('token', datum)
                .on({
                    'change': function (e) { change.call(elm); },
                    'click': function (e) { e.stopPropagation(); }
                });

            if (checked) {
                row.addClass('selected');
                input.attr('checked', true);
            }

            return row;
        }

        function vals(values) {
            this.data(dataName).values = values ? _.map(values, function (o) { return '' + o; }) : [];
        }

        function destroy() {
            this.off('click', checkboxModal.open);
            var model = this.data(dataName).modal;
            if (model) modal.remove();
            this.removeData(dataName);
        }

        function change() {
            var checkboxes = $('input[type=checkbox]', this.data(dataName).modal);

            var tokens = [];
            $.each(checkboxes, function () {
                var token = $(this).data('token');

                $(this).closest('.ch-checkboxModal-row').toggleClass('selected', this.checked);

                if (this.checked) {
                    tokens.push(token);
                }
            });

            var values = _.map(tokens, function (o) { return '' + o.value; });

            this.trigger('checkboxModal:change', {
                tokens: tokens,
                values: values
            });

            vals.call(this, values);
        }

        return {
            init: init,
            open: open,
            vals: vals,
            destroy: destroy
        };
    }());

    $.fn.chCheckboxModal = function (method) {
        if (checkboxModal[method]) {
            checkboxModal[method].apply(this, [].slice.call(arguments, 1));
        } else {
            checkboxModal.init.apply(this, arguments);
        }
        return this;
    };
}($, _, chTypeAhead.engines, chTypeAhead.dataSets));









